import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from '../service';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})


export class FormComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  public onPageUnload($event: BeforeUnloadEvent) {
    $event.returnValue = true;

  }

  isShown: boolean = false;
  activatedRoute: any;
  fafName: string;
  falName: string;
  safName: string;
  salName: string;
  fcfName: string;
  fclName: string;
  scfName: string;
  sclName: string;
  date: Date;
  formdata;
  rrspObj: Object;
  comments: string;
  firstAdvisor: object;
  clientForm: object;

  constructor(
    public quiz: Service,
    public router: Router,
    public route: ActivatedRoute,
    public googleAnalyticsService: GoogleAnalyticsService
  ) { }

  onClickSubmit() {
    //Form Validation
    if (!this.fafName || !this.falName) {
      alert("Please Enter advisor Name");
      return;
    }
    if (!this.fcfName || !this.fclName) {
      alert("Please Enter client Name");
      return;
    }
    if (!this.date) {
      alert("Please Enter date");
      return;
    }
    if (this.safName && !this.salName || this.salName && !this.safName) {
      alert("Please Enter full name for second advisor");
      return;
    }
    if (this.scfName && !this.sclName || this.sclName && !this.scfName) {
      alert("Please Enter full name for second client");
      return;
    }



    //put advisor in local storage
    var fafName = this.fafName;
    var falName = this.falName;
    this.firstAdvisor = {
      fafName,
      falName,
    }
    var advisorKey = JSON.stringify(12);
    localStorage.setItem(advisorKey, JSON.stringify(this.firstAdvisor));


    // store second advisor and client detail in session storage
    var safName = this.safName;
    var salName = this.salName;
    var fcfName = this.fcfName;
    var fclName = this.fclName;
    var scfName = this.scfName;
    var sclName = this.sclName;
    var date = this.date;
    var comments = this.comments;


    this.clientForm = {
      safName,
      salName,
      fcfName,
      fclName,
      scfName,
      sclName,
      date,
      comments

    };
    var key = JSON.stringify(13);
    sessionStorage.setItem(key, JSON.stringify(this.clientForm));

    //Call Google Analytics Event to store form data
    this.googleAnalyticsService.eventEmitter("Form_Submit", "Form", JSON.stringify([
      "Advisor", this.fafName, this.falName,
      "Client", this.fcfName, fclName]));
      console.log(JSON.stringify(["Advisor", this.fafName, this.falName,"Client", this.fcfName, fclName]));
    
      // navigate to report section
    this.router.navigateByUrl("/report");

  }
  
  ngOnInit() {
    //assign first advisor local storage value to form field
    var getAdvisor = localStorage.getItem(JSON.stringify(12));
    getAdvisor = JSON.parse(getAdvisor);
    if (getAdvisor) {
      var fafName = getAdvisor["fafName"];
      var falName = getAdvisor["falName"];

      this.fafName = fafName;
      this.falName = falName;
    }

    // assing form session value to form fields
    var getForm = sessionStorage.getItem(JSON.stringify(13));
    getForm = JSON.parse(getForm);
    if (getForm) {
      var safName = getForm["safName"];
      var salName = getForm["salName"];
      var fcfName = getForm["fcfName"];
      var fclName = getForm["fclName"];
      var scfName = getForm["scfName"];
      var sclName = getForm["sclName"];
      var date = getForm["date"];
      var comments = getForm["comments"];

      this.safName = safName;
      this.salName = salName;
      this.fcfName = fcfName;
      this.fclName = fclName;
      this.scfName = scfName;
      this.sclName = sclName;
      this.date = date;
      this.comments = comments;
    }

  }

}
